


































import Vue from "vue";
import router from "@/router";
import store from "@/store";
import loginService from "@/services/identity-authen/loginService";
import TryAnotherMethod from "./partials/TryAnotherMethod.vue";
import SignOut from "./partials/SignOut.vue";
import userInfoProvider from "@/services/userInfoProvider";

import defaultDataProviderFactory from "@/services/identity-authen/defaultDataProvider";
const defaultDataProvider = defaultDataProviderFactory();

export default Vue.extend({
  components: {
    TryAnotherMethod,
    SignOut
  },
  data() {
    return {
      error: "",
      response: null,
      loading: false
    };
  },
  methods: {
    logoutFunc() {
      userInfoProvider.deleteAccessToken();
      this.prepare();
    },
    tryMfa(mfa, resend) {
      this.prepare({
        expected_mfas: [mfa],
        force_new_session: resend
      });
    },
    async prepare(params: any = {}) {
      const ctx = this.$route.query.ctx || "";
      const query = {
        ctx
      };

      this.error = "";
      this.loading = true;
      this.response = null;
      try {
        const { body } = await defaultDataProvider.execute("PrepareLogin", {
          body: params
        });
        this.response = body;
        loginService.setPrepareLoginResponse(body);
        if (body.error_info && body.error_info.error_code) {
          this.error = body.error_info.message;
          this.loading = false;
        } else {
          if (!body.type) {
            const ctx = this.$route.query.ctx;
            if (ctx === "downloadIos") {
              router.push({
                path: "/download",
                query
              });
            } else {
              router.push({
                path: "/mfa-management",
                query
              });
            }
          } else {
            switch (body.type) {
              case "UsernamePassword":
                this.$router.push({
                  path: "username-password",
                  query
                });
                break;
              case "Totp":
                this.$router.push({
                  path: "totp-login",
                  query
                });
                break;
              case "SmsOtp":
                this.$router.push({
                  path: "sms-otp-login",
                  query
                });
                break;
              case "EmailOtp":
                this.$router.push({
                  path: "email-otp-login",
                  query
                });
                break;
              case "SecurityKey":
                this.$router.push({
                  path: "security_key",
                  query
                });
                break;
            }
          }
        }
      } catch (e) {
        this.error = e;
      } finally {
        this.loading = false;
      }
    }
  },
  async created() {
    const params: any = {};
    if (this.$route.query.type) {
      params.expected_mfas = [this.$route.query.type];
    }
    if (this.$route.query.resend && JSON.parse(this.$route.query.resend)) {
      params.force_new_session = true;
    }
    this.prepare(params);
  }
});
